module.exports = __webpack_public_path__ + "img/Time_management_w_1.9a42af2c.svg";